import Card from '../components/Card';
import StatusBadge from '../components/StatusBadge';
import { Users, Link as LinkIcon, Copy } from 'lucide-react';
import type { Referral } from '../types';

const referrals: Referral[] = [
    {
        id: '1',
        username: 'john_doe',
        date: '2024-03-10',
        status: 'active'
    },
    {
        id: '2',
        username: 'jane_smith',
        date: '2024-03-09',
        status: 'inactive'
    }
];

export default function Referrals() {
    const referralLink = 'https://example.com/ref/user123';

    const copyToClipboard = () => {
        navigator.clipboard.writeText(referralLink);
    };

    return (
        <div className="space-y-6">
            <h1 className="text-2xl font-bold text-gray-900">Referrals</h1>

            <div className="grid md:grid-cols-2 gap-6">
                <Card className="bg-gradient-to-br from-[#001f3f] to-navy-700 text-white">
                    <div className="flex items-center justify-between mb-4">
                        <div>
                            <p className="text-gray-200">Total Referrals</p>
                            <h3 className="text-3xl font-bold mt-1">24</h3>
                        </div>
                        <Users size={32} className="opacity-80" />
                    </div>
                    <div className="flex items-center gap-2">
                        <div className="flex-1">
                            <p className="text-sm text-gray-200 mb-1">Active Referrals</p>
                            <div className="h-2 bg-navy-900 rounded-full overflow-hidden">
                                <div className="h-full bg-green-400 rounded-full" style={{ width: '75%' }}></div>
                            </div>
                        </div>
                        <span className="text-lg font-semibold">18</span>
                    </div>
                </Card>

                <Card>
                    <div className="flex items-center gap-4 mb-4">
                        <LinkIcon size={24} className="text-navy-700" />
                        <div>
                            <h3 className="font-semibold text-gray-900">Your Referral Link</h3>
                            <p className="text-sm text-gray-600">Share this link to earn rewards</p>
                        </div>
                    </div>
                    <div className="flex gap-2">
                        <input
                            type="text"
                            value={referralLink}
                            readOnly
                            className="flex-1 px-4 py-2 bg-gray-50 rounded-lg text-gray-600 focus:outline-none"
                        />
                        <button
                            onClick={copyToClipboard}
                            className="px-4 py-2 bg-navy-700 text-white rounded-lg hover:bg-navy-800 transition-colors flex items-center gap-2"
                        >
                            <Copy size={16} />
                            Copy
                        </button>
                    </div>
                </Card>
            </div>

            <Card title="Referral History">
                <div className="overflow-x-auto">
                    <table className="w-full">
                        <thead>
                        <tr className="text-left border-b border-gray-200">
                            <th className="pb-3 font-semibold text-gray-600">Username</th>
                            <th className="pb-3 font-semibold text-gray-600">Date</th>
                            <th className="pb-3 font-semibold text-gray-600">Status</th>
                        </tr>
                        </thead>
                        <tbody>
                        {referrals.map((referral) => (
                            <tr key={referral.id} className="border-b border-gray-100">
                                <td className="py-4 text-gray-900">{referral.username}</td>
                                <td className="py-4 text-gray-600">{referral.date}</td>
                                <td className="py-4">
                                    <StatusBadge status={referral.status} />
                                </td>
                            </tr>
                        ))}
                        </tbody>
                    </table>
                </div>
            </Card>
        </div>
    );
}